export function encodeIFrameLoginState(transactionId) {
    return btoa(JSON.stringify({ transactionId }));
}
export function getIFrameLoginTransactionId(state) {
    if (!state) {
        return undefined;
    }
    try {
        const standardBase64 = state.replace(/-/g, "+").replace(/_/g, "/");
        const paddedBase64 = standardBase64.padEnd(Math.ceil(standardBase64.length / 4) * 4, "=");
        const parsed = JSON.parse(atob(paddedBase64));
        if (typeof parsed !== "object" || parsed === null) {
            return undefined;
        }
        const transactionId = parsed.transactionId;
        return typeof transactionId === "string" && transactionId.length > 0 ? transactionId : undefined;
    }
    catch {
        return undefined;
    }
}
